import Faq from ".";

export const faqRoutes = (data) => [
  {
    path: "/admin/faq",
    title: "events",
    layout: "admin",
    routeType: "admin",
    component: Faq,
  },
];
